// Supervision de base (H7-07, D-008) : filtres des routes /supervision et liste fermée des
// colonnes autorisées dans les réponses. Aucune colonne ne désigne une personne : seules des
// organisations, des territoires et des agrégats transitent.
import { z } from 'zod';
import { schemaTypeOrganisation } from './organisations';

export const INSTITUTIONS_SUPERVISION = ['ministere', 'regulateur', 'coordination_provinciale'] as const;
/** Institutions dont le périmètre territorial est obligatoire (D-027). */
export const INSTITUTIONS_A_PERIMETRE = ['coordination_provinciale'] as const;

export const COLONNES_SUPERVISION = {
  repertoire: [
    'organisation_id',
    'code_court',
    'nom',
    'type',
    'province_code',
    'province_nom',
    'departement_code',
    'departement_nom',
    'statut_deploiement',
    'fictive',
    'sigle',
    'domaine',
  ],
  deploiement: [
    'organisation_id',
    'code_court',
    'nom',
    'type',
    'province_code',
    'departement_code',
    'statut_deploiement',
    'fictive',
    'domaine',
    'modules_actifs',
    'nombre_modules_actifs',
    'utilisateurs_actifs_30j',
    'demarches_publiees',
    'derniere_activite',
    'calcule_le',
  ],
  dossiers: ['organisation_id', 'code_court', 'nom', 'province_code', 'mois', 'recus', 'clotures', 'delai_median_jours', 'en_retard', 'calcule_le'],
} as const;
export type VueSupervision = keyof typeof COLONNES_SUPERVISION;
export const VUES_SUPERVISION = Object.keys(COLONNES_SUPERVISION) as VueSupervision[];

/** Motif de nom de colonne évoquant une personne : refusé dans toute réponse de supervision. */
export const MOTIF_COLONNE_NOMINATIVE =
  /(^|_)(compte|appartenance|identifiant|courriel|telephone|prenoms?|usager|agent|tiers|auteur|instructeur|session|adresse|beneficiaire|numero)(_|$)/;

const code = z.string().trim().regex(/^[A-Z0-9-]{1,10}$/, 'Code territorial invalide');

export const schemaFiltreRepertoire = z.object({
  province: code.optional(),
  departement: code.optional(),
  type: schemaTypeOrganisation.optional(),
});

export const schemaFiltreDossiersSupervision = schemaFiltreRepertoire.extend({
  debut: z.iso.date('Date AAAA-MM-JJ attendue').optional(),
  fin: z.iso.date('Date AAAA-MM-JJ attendue').optional(),
});

export const FORMATS_EXPORT_TABLEAU = ['csv', 'xlsx'] as const;

export const schemaExportSupervision = schemaFiltreDossiersSupervision.extend({
  vue: z.enum(VUES_SUPERVISION as [VueSupervision, ...VueSupervision[]]).default('deploiement'),
  format: z.enum(FORMATS_EXPORT_TABLEAU).default('csv'),
});

export const schemaRafraichissementAgregats = z.object({
  vue: z.enum(['deploiement', 'dossiers']).optional(),
});
